/** Settings communications section i18n keys — register via the app i18n generation pipeline. */
export const COMMUNICATIONS_PREFERENCES_I18N = {
  heading: 'COMMUNICATIONS',
  smsUpdates: 'SMS_UPDATES',
  emailUpdates: 'EMAIL_UPDATES',
  /** Success toast after PATCH (`CadsGlobalToastService.success`). */
  patchSuccess: 'COMMUNICATIONS_PREFERENCES_UPDATED',
  /** Error toast after PATCH (`CadsGlobalToastService.error`); reuses app-wide generic error copy. */
  patchError: 'ERROR_GENERAL_DESC',
} as const;
